




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Badge from '@/components/Badges/Badge.vue';

@Component({
    components: {
        Badge,
    },
})
export default class FlatTabs extends Vue {
    @Prop() public tabs: any;
    @Prop() public activeTab: string;
    @Prop({ default: '' }) public tabClasses: string;

    constructor() {
        super();
    }

    get classes() {
        return this.tabClasses;
    }

    public toggleTab(event: any, tab: string) {
        this.$emit('tabChanged', tab);
    }
}
